import React, { useState, useEffect, useCallback } from 'react';
import { Typography, Divider, Paper } from '@mui/material';
import { get } from '../../../services/api-services';
import { useParams } from 'react-router-dom';
import AddMeasurmentDialog from '../profileModel-DialogBox/AddMeasurmentDialog';
import MeasurementSection from '../MeasurementSection';

const Measurement = ({ userData, fetchUserData }) => {
    const [measurements, setMeasurements] = useState([]);
    const [loading, setLoading] = useState(true);
    const { id } = useParams();
    const [isOpneDialog, setIsOpenDialog] = useState(false);
    const [measurementType, setMeasurementType] = useState(null);
    const [measurementData, setMeasurementData] = useState({
        type: '',
        value: '',
        unit: "Kgs",
        recordedAt: new Date(),
        createdAt: new Date(),
        updatedAt: new Date(),
        customerId: id,
        userComment: ""
    });

    const measurementTypes = [
        'weight', 'chestSize', 'waistSize', 'hipsSize', 'thighsSize', 'neck',
        'armsSize', 'overallBodyFat', 'skeletalMuscleFat', 'visceralFat',
        'subcutaneousFat', 'bmr', 'height'
    ];

    const fetchData = useCallback(async () => {
        const url = `/Measurements?filter={"where":{"customerId":"${id}"},"order":"recordedAt DESC"}`;
        try {
            const response = await get(url);
            if (response && response.data) {
                setMeasurements(response.data);
                setLoading(false);
            }
        } catch (error) {
            console.error('Error fetching measurements:', error);
            setLoading(false);
        }
    }, [id]);

    const GraphfetchData = async (type) => {
        const url = `/Measurements?filter={"where":{"customerId":"${id}","type":"${type}"},"order":"recordedAt DESC","limit":30}`;
        try {
            const response = await get(url);
            if (response && response.data) {
                setMeasurements(prevMeasurements => {
                    const updatedMeasurements = prevMeasurements.filter(m => m.type !== type);
                    return [...updatedMeasurements, ...response.data];
                });
            }
        } catch (error) {
            console.error('Error fetching graph data:', error);
        }
    };

    const formatTypeMessage = (type) => {
        if (!type) {
            return '';
        }

        const formattedType = type
            .replace(/([A-Z])/g, ' $1')  // Add space before uppercase letters
            .toLowerCase()               // Convert to lowercase
            .replace(/^./, (str) => str.toUpperCase());  // Capitalize the first letter

        return formattedType;
    };

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const handleAddClick = (type) => {
        setIsOpenDialog(true);
        setMeasurementType(type);
        setMeasurementData({
            type,
            value: '',
            unit: type === 'weight'
                ? 'kgs'
                : ['thighsSize', 'chestSize', 'waistSize', 'hipsSize', 'height', 'neck', 'armsSize'].includes(type)
                    ? 'cms'
                    : ['overallBodyFat', 'skeletalMuscleFat', 'visceralFat', 'subcutaneousFat'].includes(type)
                        ? '%'
                        : type === 'bmr'
                            ? 'Cal/day'
                            : '',
            recordedAt: new Date(),
            createdAt: new Date(),
            updatedAt: new Date(),
            customerId: id,
            userComment: ""
        });
    };

    if (loading) {
        return <Typography>Loading...</Typography>;
    }

    return (
        <Paper sx={{ boxShadow: 1, borderRadius: 1, p: 2 }}>
            {measurementTypes.map((type) => {
                const measurement = measurements.find(m => m.type === type);
                return (
                    <div key={type}>
                        <MeasurementSection
                            title={formatTypeMessage(type)}
                            currentValue={measurement?.value || ''}
                            unit={measurement?.unit || ''}
                            type={type}
                            userComment={measurement?.userComment || ''}
                            onAddClick={handleAddClick}
                            measurements={measurements}
                            formatTypeMessage={formatTypeMessage}
                        />
                        <Divider />
                    </div>
                );
            })}

            <AddMeasurmentDialog
                open={isOpneDialog}
                onClose={() => setIsOpenDialog(false)}
                type={measurementType}
                measurementData={measurementData}
                setMeasurementData={setMeasurementData}
                fetchData={fetchData}
                GraphfetchData={GraphfetchData}
                measurements={measurements}
                formatTypeMessage={formatTypeMessage}
                userData={userData}
                fetchUserData={fetchUserData}
            />
        </Paper>
    );
};

export default Measurement;
